import React, { useState, useEffect } from "react";
import { deleteFollower, getFollowing } from "../../api";
import { Link } from "react-router-dom";
import ToastMessage from "../../components/ToastMessage";
import { getMediaUrl } from "../../lib/utils";

import {
  FiUserMinus,
  FiUserCheck,
  FiUsers,
} from "react-icons/fi";

const Followings = () => {
  const [followings, setFollowings] = useState();

  useEffect(() => {
    getFollowing().then((res) => {
      setFollowings(res.data);
    });
  }, []);

  const unFollow = (id) => {
    deleteFollower(id).then((res) => {
      ToastMessage(res.data.message);
    });
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 px-4 py-6 sm:px-6 lg:px-8">

      {/* HEADER */}
      <div className="mx-auto w-full max-w-4xl">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-purple-100 text-purple-600">
            <FiUsers size={21} />
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 sm:text-2xl">
              All Following
            </h2>

            <p className="mt-1 text-sm text-gray-400">
              People you currently follow
            </p>
          </div>
        </div>

        {/* EMPTY STATE */}
        {followings?.length === 0 ? (
          <div className="flex min-h-[420px] flex-col items-center justify-center rounded-3xl border border-gray-100 bg-white px-6 text-center shadow-sm">
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-purple-50 text-purple-500">
              <FiUsers size={28} />
            </div>

            <h3 className="mt-4 text-lg font-semibold text-gray-900">
              No following yet
            </h3>

            <p className="mt-2 max-w-sm text-sm leading-6 text-gray-400">
              When you start following people, they will appear here.
            </p>
          </div>
        ) : (
          <div className="space-y-3">

            {followings?.map((following) => (
              <div
                key={following?.id}
                className="
                  group
                  flex
                  flex-col
                  gap-4
                  rounded-2xl
                  border
                  border-gray-100
                  bg-white
                  p-4
                  shadow-sm
                  transition-all
                  duration-200

                  hover:-translate-y-[1px]
                  hover:border-purple-100
                  hover:shadow-md

                  sm:flex-row
                  sm:items-center
                  sm:justify-between
                "
              >

                {/* USER INFO */}
                <Link
                  to={`/profile/${following?.id}`}
                  className="flex min-w-0 items-center gap-4"
                >
                  <div className="relative shrink-0">
                    <img
                      src={getMediaUrl(following?.profile_img)}
                      alt={`${following?.firstname} ${following?.lastname}`}
                      className="
                        h-16
                        w-16
                        rounded-full
                        object-cover
                        object-center
                        ring-2
                        ring-gray-100
                        transition
                        group-hover:ring-purple-100
                      "
                    />
                  </div>

                  <div className="min-w-0">
                    <h3 className="truncate text-base font-semibold text-gray-900">
                      {following?.firstname} {following?.lastname}
                    </h3>

                    <p className="mt-1 text-sm text-gray-400">
                      You follow this person
                    </p>
                  </div>
                </Link>

                {/* ACTIONS */}
                <div className="flex items-center gap-2 sm:shrink-0">

                  <button
                    type="button"
                    onClick={() => unFollow(following?.id)}
                    className="
                      flex
                      items-center
                      justify-center
                      gap-2
                      rounded-xl
                      border
                      border-red-100
                      bg-red-50
                      px-4
                      py-2.5
                      text-sm
                      font-semibold
                      text-red-500
                      transition-all
                      duration-200

                      hover:border-red-200
                      hover:bg-red-100
                      hover:text-red-600

                      active:scale-[0.98]
                    "
                  >
                    <FiUserMinus size={17} />
                    Unfollow
                  </button>

                  <Link
                    to={`/profile/${following?.id}`}
                    className="
                      flex
                      items-center
                      justify-center
                      rounded-xl
                      border
                      border-gray-200
                      bg-white
                      px-4
                      py-2.5
                      text-sm
                      font-semibold
                      text-gray-600
                      transition-all
                      duration-200

                      hover:border-purple-200
                      hover:bg-purple-50
                      hover:text-purple-600
                    "
                  >
                    Profile
                  </Link>
                </div>
              </div>
            ))}

          </div>
        )}
      </div>
    </div>
  );
};

export default Followings;